import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
    CALCULATE_QUOTATION,
    CREATE_QUOTATION,
    UPDATE_QUOTATION,
    DELETE_QUOTATION,
    GET_QUOTATION_DETAILS,
    GET_QUOTATION_FILTERS,
    GET_QUOTATION_LISTING,
    SEND_QUOTATION_EMAIL,
    SEND_QUOTATION_WHATSAPP,
} from "./actionTypes.js";

import {
    calculateQuotationFail,
    calculateQuotationSuccess,
    createQuotationFail,
    createQuotationSuccess,
    updateQuotationFail,
    updateQuotationSuccess,
    deleteQuotationFail,
    deleteQuotationSuccess,
    getQuotationDetailsFail,
    getQuotationDetailsSuccess,
    getQuotationFiltersFail,
    getQuotationFiltersSuccess,
    getQuotationListingFail,
    getQuotationListingSuccess,
    sendQuotationEmailFail,
    sendQuotationEmailSuccess,
    sendQuotationWhatsappFail,
    sendQuotationWhatsappSuccess,
} from "./actions.js";

import { quotationCalculateApi, quotationCreateApi, quotationDeleteApi, quotationDetailsApi, quotationEmailApi, quotationFiltersApi, quotationListingApi, quotationUpdateApi, quotationWhatsappApi } from "./quotationApi.js";

function* fetchQuotationListing({ payload }) {
    try {
        const response = yield call(quotationListingApi, payload);
        yield put(getQuotationListingSuccess(response));
    } catch (error) {
        yield put(getQuotationListingFail(error));
    }
}

function* fetchQuotationDetails({ payload }) {
    try {
        const response = yield call(quotationDetailsApi, payload);
        yield put(getQuotationDetailsSuccess(response));
    } catch (error) {
        yield put(getQuotationDetailsFail(error));
    }
}
function* fetchQuotationCreate({ payload }) {
    try {
        const response = yield call(quotationCreateApi, payload);
        yield put(createQuotationSuccess(response));
    } catch (error) 
    {
        yield put(createQuotationFail(error));
    }
}

function* fetchQuotationDelete({ payload }) {
    try {
        const response = yield call(quotationDeleteApi, payload);
        yield put(deleteQuotationSuccess(response));
    } catch (error) {
        yield put(deleteQuotationFail(error));
    }
}

function* fetchQuotationFilters() {
    try {
        const response = yield call(quotationFiltersApi);
        yield put(getQuotationFiltersSuccess(response));
    } catch (error) {
        yield put(getQuotationFiltersFail(error));
    }
}

function* fetchQuotationUpdate({ payload }) {
    try {
        const response = yield call(quotationUpdateApi, payload);
        yield put(updateQuotationSuccess(response));
    } catch (error) {
        yield put(updateQuotationFail(error));
    }
}

function* fetchQuotationCalculate({ payload }) {
    try {
        const response = yield call(quotationCalculateApi, payload);
        yield put(calculateQuotationSuccess(response));
    } catch (error) {
        yield put(calculateQuotationFail(error));
    }
}

function* fetchQuotationEmail({ payload }) {
    try {
        const response = yield call(quotationEmailApi, payload);
        yield put(sendQuotationEmailSuccess(response));
    } catch (error) {
        yield put(sendQuotationEmailFail(error));
    }
}

function* fetchQuotationWhatsapp({ payload }) {
    try {
        const response = yield call(quotationWhatsappApi, payload);
        yield put(sendQuotationWhatsappSuccess(response));
    } catch (error) {
        yield put(sendQuotationWhatsappFail(error));
    }
}


function* QuotationSaga() {
    yield takeEvery(GET_QUOTATION_LISTING, fetchQuotationListing);
    yield takeEvery(GET_QUOTATION_FILTERS, fetchQuotationFilters);
    yield takeEvery(GET_QUOTATION_DETAILS, fetchQuotationDetails);
    yield takeEvery(CREATE_QUOTATION, fetchQuotationCreate);
    yield takeEvery(UPDATE_QUOTATION, fetchQuotationUpdate);
    yield takeEvery(DELETE_QUOTATION, fetchQuotationDelete);
    yield takeEvery(CALCULATE_QUOTATION, fetchQuotationCalculate);
    yield takeEvery(SEND_QUOTATION_EMAIL, fetchQuotationEmail);
    yield takeEvery(SEND_QUOTATION_WHATSAPP, fetchQuotationWhatsapp);
}

export default QuotationSaga
